import { useRef, useState } from 'react';
import {
  NotificationIconButton,
  NotificationFeedPopover,
  useKnockClient,
} from '@knocklabs/react';

export function NotificationBell() {
  const [isVisible, setIsVisible] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  // Guard: if KnockProvider is not mounted, render nothing
  try {
    useKnockClient();
  } catch {
    return null;
  }

  return (
    <>
      <NotificationIconButton
        ref={buttonRef}
        onClick={() => setIsVisible(!isVisible)}
      />
      <NotificationFeedPopover
        buttonRef={buttonRef}
        isVisible={isVisible}
        onClose={() => setIsVisible(false)}
      />
    </>
  );
}
